import { createTheme } from "@mui/material/styles";
import lightPalette from "./lightTheme";

const theme = createTheme({
  palette: lightPalette,
  typography: {
    fontFamily: [
      "Poppins", // Specify the Poppins font
      "sans-serif",
    ].join(","),
    h1: {
      color: "#202020"
    }
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input": {
            padding: "10px 16px", // Adjust the padding here
          },
        },
      },
    },

    MuiPaginationItem: {
      styleOverrides: {
        root: {
          // backgroundColor: "#fff", // Background color for pagination items
          "&.Mui-selected": {
            backgroundColor: "#00ABF4", // Different color for selected item
            color: "#fff",
          },
        },
      },
    },
  },


  
});

export default theme;
